// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"amazonpets_wrapper__67CQR","container":"amazonpets_container__ev0Cp","copy":"amazonpets_copy__BaSxQ","form":"amazonpets_form__U_OS1"};